// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}
.p-datatable .p-datatable-tbody > tr > td {
  padding: 0.5rem !important;
}
.p-button.p-button-icon-only.p-button-rounded {
  height: 2rem !important;
}
.p-button.p-button-icon-only {
  width: 2rem !important;
}
.p-toolbar {
  padding: 0.5rem !important;
}
.card {
  padding: 1rem !important;
}
.field {
  margin-bottom:0 !important;
}
.p-button.p-button-icon-only {
  padding: 0.5rem 0 !important;
}


.blue-tooltip.p-tooltip .p-tooltip-arrow {
  border-top-color: var(--blue-500);
}
.blue-tooltip.p-tooltip .p-tooltip-text {
  background-color: var(--blue-500);
}
.green-tooltip.p-tooltip .p-tooltip-arrow {
  border-top-color: var(--green-500);
}
.green-tooltip.p-tooltip .p-tooltip-text {
  background-color: var(--green-500);
}
.yellow-tooltip.p-tooltip .p-tooltip-arrow {
  border-top-color: var(--yellow-500);
}
.yellow-tooltip.p-tooltip .p-tooltip-text {
  background-color: var(--yellow-500);
}
.cyan-tooltip.p-tooltip .p-tooltip-arrow {
  border-top-color: var(--cyan-500);
}
.cyan-tooltip.p-tooltip .p-tooltip-text {
  background-color: var(--cyan-500);
}
.pink-tooltip.p-tooltip .p-tooltip-arrow {
  border-top-color: var(--pink-500);
}
.pink-tooltip.p-tooltip .p-tooltip-text {
  background-color: var(--pink-500);
}
.indigo-tooltip.p-tooltip .p-tooltip-arrow {
  border-top-color: var(--indigo-500);
}
.indigo-tooltip.p-tooltip .p-tooltip-text {
  background-color: var(--indigo-500);
}
.teal-tooltip.p-tooltip .p-tooltip-arrow {
  border-top-color: var(--teal-500);
}
.teal-tooltip.p-tooltip .p-tooltip-text {
  background-color: var(--teal-500);
}
.bluegray-tooltip.p-tooltip .p-tooltip-arrow {
  border-top-color: var(--bluegray-500);
}
.bluegray-tooltip.p-tooltip .p-tooltip-text {
  background-color: var(--bluegray-500);
}
.purple-tooltip.p-tooltip .p-tooltip-arrow {
  border-top-color: var(--purple-500);
}
.purple-tooltip.p-tooltip .p-tooltip-text {
  background-color: var(--purple-500);
}

.p-treeselect-token {
  display: none !important;
}

.p-timeline-event-opposite {
  display: none !important;
}

.change-disabled .p-disabled, .change-disabled .p-component:disabled {
  background-color: #f2f2f2 !important;
  opacity: 1 !important;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE;aACW;AACb;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,4BAA4B;AAC9B;;;AAGA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,qCAAqC;AACvC;AACA;EACE,qCAAqC;AACvC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,mCAAmC;AACrC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;AACvB","sourcesContent":["body {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n.p-datatable .p-datatable-tbody > tr > td {\n  padding: 0.5rem !important;\n}\n.p-button.p-button-icon-only.p-button-rounded {\n  height: 2rem !important;\n}\n.p-button.p-button-icon-only {\n  width: 2rem !important;\n}\n.p-toolbar {\n  padding: 0.5rem !important;\n}\n.card {\n  padding: 1rem !important;\n}\n.field {\n  margin-bottom:0 !important;\n}\n.p-button.p-button-icon-only {\n  padding: 0.5rem 0 !important;\n}\n\n\n.blue-tooltip.p-tooltip .p-tooltip-arrow {\n  border-top-color: var(--blue-500);\n}\n.blue-tooltip.p-tooltip .p-tooltip-text {\n  background-color: var(--blue-500);\n}\n.green-tooltip.p-tooltip .p-tooltip-arrow {\n  border-top-color: var(--green-500);\n}\n.green-tooltip.p-tooltip .p-tooltip-text {\n  background-color: var(--green-500);\n}\n.yellow-tooltip.p-tooltip .p-tooltip-arrow {\n  border-top-color: var(--yellow-500);\n}\n.yellow-tooltip.p-tooltip .p-tooltip-text {\n  background-color: var(--yellow-500);\n}\n.cyan-tooltip.p-tooltip .p-tooltip-arrow {\n  border-top-color: var(--cyan-500);\n}\n.cyan-tooltip.p-tooltip .p-tooltip-text {\n  background-color: var(--cyan-500);\n}\n.pink-tooltip.p-tooltip .p-tooltip-arrow {\n  border-top-color: var(--pink-500);\n}\n.pink-tooltip.p-tooltip .p-tooltip-text {\n  background-color: var(--pink-500);\n}\n.indigo-tooltip.p-tooltip .p-tooltip-arrow {\n  border-top-color: var(--indigo-500);\n}\n.indigo-tooltip.p-tooltip .p-tooltip-text {\n  background-color: var(--indigo-500);\n}\n.teal-tooltip.p-tooltip .p-tooltip-arrow {\n  border-top-color: var(--teal-500);\n}\n.teal-tooltip.p-tooltip .p-tooltip-text {\n  background-color: var(--teal-500);\n}\n.bluegray-tooltip.p-tooltip .p-tooltip-arrow {\n  border-top-color: var(--bluegray-500);\n}\n.bluegray-tooltip.p-tooltip .p-tooltip-text {\n  background-color: var(--bluegray-500);\n}\n.purple-tooltip.p-tooltip .p-tooltip-arrow {\n  border-top-color: var(--purple-500);\n}\n.purple-tooltip.p-tooltip .p-tooltip-text {\n  background-color: var(--purple-500);\n}\n\n.p-treeselect-token {\n  display: none !important;\n}\n\n.p-timeline-event-opposite {\n  display: none !important;\n}\n\n.change-disabled .p-disabled, .change-disabled .p-component:disabled {\n  background-color: #f2f2f2 !important;\n  opacity: 1 !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
